// extracted by mini-css-extract-plugin
export var contentBody = "_c9-9";
export var headerImage = "_c9-2";
export var imageButton = "_c9-7";
export var imageButtonIcon = "_c9-8";
export var imageHeader = "_c9-4";
export var imageHeaderText = "_c9-5";
export var imageOverlay = "_c9-3";
export var imageTitle = "_c9-6";
export var imageWrapper = "_c9-1";
export var taskList = "_c9-a";
export var widget = "_c9-0";